export default __webpack_public_path__ + "static/media/sundar1.eb1b4bca.png";